import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './MorePage.css'; 
import { AuthContext } from '../context/AuthContext';
import arrowIcon from '../assets/icons/arrow-icon.png';
import logoutIcon from '../assets/icons/logout-icon.png';

const MorePage = ({isTelegramMiniApp}) => {
    const navigate = useNavigate();
    const [showUserAgreement, setShowUserAgreement] = useState(false);
    const { t } = useTranslation('more');

    useEffect(() => {
        const handlePopState = (event) => {
            event.preventDefault();
            navigate('/game'); 
        };

        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [navigate]);

    const { logout } = useContext(AuthContext);

    const handleGamesHistoryClick = () => {
        navigate('/played-games-history');
    };

    const handleTransactionHistoryClick = () => {
        navigate('/transaction-history');
    };

    const handleAffiliateProgramClick = () => {
        navigate('/affiliate-program');
    };

    const handleUserAgreementClick = () => {
        setShowUserAgreement(true); 
    };

    const handleChatWithSupportClick = () => {
        window.open('https://t.me/TG_Games_Support_bot', '_blank');
    };

    const handleCloseUserAgreement = () => {
        setShowUserAgreement(false); 
    };

        const menuItems = [
        { key: 'played_games', handler: handleGamesHistoryClick },
        { key: 'transaction_history', handler: handleTransactionHistoryClick },
        { key: 'affiliate_program', handler: handleAffiliateProgramClick },
        { key: 'user_agreement', handler: handleUserAgreementClick },
        { key: 'support_chat', handler: handleChatWithSupportClick }
    ];
    const tg = window.Telegram?.WebApp;

    return (
        <div className="more-page-container">
            <h2 className="more-page-title">{t('title')}</h2>
            <ul className="more-options-list">
                {menuItems.map((item) => (
                    <li key={item.key} className="more-option-item" onClick={item.handler}>
                        <span className="more-option-text">{t(`options.${item.key}`)}</span>
                        <img className="more-option-arrow" src={arrowIcon} alt="" />
                    </li>
                ))}
                {!tg.initData && (
                    <li className="more-option-item" onClick={logout}>
                        <span className="more-option-text-logout">{t('options.logout')}</span>
                        <img className="more-option-logout" src={logoutIcon} alt="" />
                    </li>
                )}
            </ul>

            {showUserAgreement && (
                <div className="user-agreement-popup-overlay-custom">
                    <div className="user-agreement-popup-custom">
                        <div className="user-agreement-header-custom">
                            <h3 className="user-agreement-title-custom">{t('agreement.title')}</h3>
                            <button className="user-agreement-close-btn-custom" onClick={handleCloseUserAgreement}>
                                {t('agreement.close')}
                            </button>
                        </div>
                        <div className="user-agreement-body-custom">
                            {Object.entries(t('agreement.sections', { returnObjects: true })).map(([key, section]) => (
                                <p key={key}>
                                    <strong>{section.title}</strong>
                                    <br /><br />
                                    {section.content.split('\n').map((line, i) => (
                                        <React.Fragment key={i}>
                                            {line}
                                            <br />
                                        </React.Fragment>
                                    ))}
                                </p>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MorePage;